import { useEffect, useState } from 'react';
import { FaLock, FaUnlock } from 'react-icons/fa';
import { useMoralis } from 'react-moralis';
import { toast } from 'react-toastify';
import { LockABI, TokenABI, WhiteABI } from '../../../data/ABI';
import { inChainId } from '../../../data/chainId';
import { IDMContract, LockContract, TokenContract, WhiteContract } from '../../../utility/contractAddress';
import { LoaderSpinner } from '../../atoms';
import './LockComponent.scss';


const LockComponent = ({detail}) => {
  const [whitelist, setWhitelist] = useState()
  const { Moralis } = useMoralis()
  const [loading, setLoading] = useState(false)
  async function whiteStatus() {
    let user = Moralis.User.current();
    const walletAddress = user.get("ethAddress");
    const web3 = await Moralis.enableWeb3();
    const chainIdDec = await web3.eth.getChainId();

    if (parseInt(inChainId) === parseInt(chainIdDec)) {
      const web3 = await Moralis.enableWeb3();
      let swhitecontract = new web3.eth.Contract(WhiteABI, WhiteContract);

      const wstatus = await swhitecontract.methods
        .isInWhiteList(walletAddress)
        .call();
      setWhitelist(wstatus)
    } else {
      console.log("Connect to BSC Network!");
    }
  }
  async function unlockToken() {
    try {
      setLoading(true)
      let user = Moralis.User.current();
      const walletAddress = user.get("ethAddress");
      const web3 = await Moralis.enableWeb3();
      const chainIdDec = await web3.eth.getChainId();

      if (parseInt(inChainId) === parseInt(chainIdDec)) {
        const web3 = await Moralis.enableWeb3();
        let slockcontract = new web3.eth.Contract(LockABI, LockContract);
        let swhitecontract = new web3.eth.Contract(WhiteABI, WhiteContract);

        slockcontract.methods.UnlockToken(IDMContract).send(
          {
            from: walletAddress,
            value: 0,
          },
          function (err, res) {
            if (err) {
              console.log("An error occured", err);
              toast.error("Transaction failed!")
              setLoading(false)
              return;
            }
            console.log("Hash of the transaction: " + res);
            swhitecontract.methods
              .setWhiteListAccess(walletAddress, false)
              .send(
                {
                  from: walletAddress,
                  value: 0,
                },
                function (err, res) {
                  if (err) {
                    toast.error("Transaction failed!")
                    setLoading(false)
                    return;
                  }
                  if (res) {
                    toast.success("Transaction success!")
                    setLoading(false)
                  }
                }
              );
          }
        );
      } else {
        console.log("Connect to BSC Network!");
        setLoading(false)
      }
    } catch (error) {
      console.log(error.message)
      setLoading(false)
    }
  }

  async function lockToken() {
    try {
      setLoading(true)
      let user = Moralis.User.current();
      const walletAddress = user.get("ethAddress");
      const web3 = await Moralis.enableWeb3();
      const chainIdDec = await web3.eth.getChainId();
  
      if (parseInt(inChainId) === parseInt(chainIdDec)) {
        const web3 = await Moralis.enableWeb3();
        let slockcontract = new web3.eth.Contract(LockABI, LockContract);
        let swhitecontract = new web3.eth.Contract(WhiteABI, WhiteContract);
        let tokcontract = new web3.eth.Contract(TokenABI, IDMContract);
        const amountApprove = (100000000 * 10 ** 18).toLocaleString('fullwide', { useGrouping: false });
        tokcontract.methods.approve(LockContract, amountApprove).send(
          {
            from: walletAddress,
            value: 0,
          },
          function (err, res) {
            if (err) {
              console.log("An error occured", err);
              toast.error("Transaction failed!")
              setLoading(false)
              return;
            }
            console.log("Hash of the transaction: " + res);
          }
        );
        await new Promise((r) => setTimeout(r, 10000));
        slockcontract.methods.LockToken(TokenContract).send(
          {
            from: walletAddress,
            value: 0,
          },
          function (err, res) {
            if (err) {
              console.log("An error occured", err);
              toast.error("Transaction failed!")
              setLoading(false)
              return;
            }
            console.log("Hash of the transaction: " + res);  
            swhitecontract.methods
              .setWhiteListAccess(walletAddress, true)
              .send(
                {
                  from: walletAddress,
                  value: 0,
                },
                function (err, res) {
                  if (err) {
                    toast.success("Transaction failed!")
                    setLoading(false)
                    return;
                  }
                  if (res) {
                    toast.success("Transaction success!")
                    setLoading(false)
                  }
                }
              );
          }
        );
      } else {
        console.log("Connect to BSC Network!");
        setLoading(false)
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false)
    }
  }
  useEffect(() => {
    whiteStatus()
  }, [])
  return (
    <div className="lock">
      <div className="container">
        <div className="wrapper">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <div className="cardTypeSale">
                <span className="title">Private Sale :</span>
                <span className="val">$ IDM 300.000</span>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="btnWrapper mt-3 mt-lg-0">
                <button className='btnLock' onClick={lockToken}>
                  <FaLock />
                  <span className='ms-1'>LOCK</span>
                </button>
              </div>
            </div>
          </div>
          <div className="row mt-3 align-items-center">
            <div className="col-lg-8">
              <div className="cardTypeSale">
                <span className="title">Whitelist Status</span>
                <span className="val">{`${whitelist ? 'YES' : 'NO'}`}</span>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="btnWrapper mt-3 mt-lg-0">
                <button className='btnLock' onClick={unlockToken}>
                  <FaUnlock />
                  <span className='ms-1'>UNLOCK</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        loading && <LoaderSpinner />
      }
    </div>
  )
}

export default LockComponent
